import styled from "styled-components";

const DescriptionWrapper = styled.div`
  width: 100%; /* Fix for IE 11 */
`;

export { DescriptionWrapper };



// WEBPACK FOOTER //
// ./src/previsit/components/Sidebar/styled.js